import React from 'react';
import './spinner.styles.scss';

const Spinner = () => {
  return(
    <div className="spinner-overlay">
      <div className="spinner-container"/>
    </div>
  )
}

export default Spinner;